import { Box } from '@mantine/core';

type Props = {
  children: React.ReactNode;
};

export function SiestaBarLayout({ children }: Props) {
  return (
    <Box h="100%" pos="relative" style={{ overflow: 'hidden' }}>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      >
        <source src="/sidebar-background.mp4" type="video/mp4" />
      </video>

      <Box
        pos="absolute"
        style={{
          inset: 0,
          backgroundColor: 'rgba(255, 119, 28, 0.7)',
          zIndex: 1,
        }}
      />

      <Box pos="relative" h="100%" px="xl" py="xxxl" style={{ zIndex: 2 }}>
        {children}
      </Box>
    </Box>
  );
}
